import React from "react";

export function ProductDetail() {
    return <div>ProductDetail</div>;
}
